(function () {
  if (window.__clInit) return;
  window.__clInit = true;

  /* --- Reveals --- */
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('cl-visible'); observer.unobserve(e.target); }
    });
  }, { threshold: 0.12 });

  function initReveals(root) {
    (root || document).querySelectorAll('.cl-reveal:not(.cl-visible)').forEach(function (el) { observer.observe(el); });
  }

  /* --- Beneficios: acordeón con imagen viva --- */
  function initBeneficios(root) {
    (root || document).querySelectorAll('[data-cl-beneficios]').forEach(function (sec) {
      if (sec.dataset.clInit) return; sec.dataset.clInit = '1';
      var items = sec.querySelectorAll('.cl-benef-item');
      var fotos = sec.querySelectorAll('.cl-benef-fotos img');
      items.forEach(function (item, i) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (o) { if (o !== item) o.removeAttribute('open'); });
          fotos.forEach(function (f, j) { f.classList.toggle('cl-activa', j === i); });
        });
      });
    });
  }

  /* --- Hotspots --- */
  function initHotspots(root) {
    (root || document).querySelectorAll('[data-cl-hotspots]').forEach(function (sec) {
      if (sec.dataset.clInit) return; sec.dataset.clInit = '1';
      var puntos = sec.querySelectorAll('.cl-hot-punto');
      var tabs = sec.querySelectorAll('.cl-hot-tab');
      function activa(i) {
        puntos.forEach(function (p, j) { p.classList.toggle('cl-activa', j === i); });
        tabs.forEach(function (t, j) { t.classList.toggle('cl-activa', j === i); });
      }
      puntos.forEach(function (p, i) { p.addEventListener('click', function () { activa(i); }); });
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { activa(i); }); });
    });
  }

  /* --- Antes / Después --- */
  function initComparador(root) {
    (root || document).querySelectorAll('[data-cl-comparador]').forEach(function (wrap) {
      if (wrap.dataset.clInit) return; wrap.dataset.clInit = '1';
      function setCorte(clientX) {
        var r = wrap.getBoundingClientRect();
        var pct = Math.min(96, Math.max(4, ((clientX - r.left) / r.width) * 100));
        wrap.style.setProperty('--cl-corte', pct + '%');
      }
      var arrastrando = false;
      wrap.addEventListener('pointerdown', function (e) { arrastrando = true; setCorte(e.clientX); wrap.setPointerCapture(e.pointerId); });
      wrap.addEventListener('pointermove', function (e) { if (arrastrando) setCorte(e.clientX); });
      ['pointerup', 'pointercancel'].forEach(function (ev) { wrap.addEventListener(ev, function () { arrastrando = false; }); });
      var asa = wrap.querySelector('.cl-ba-boton');
      if (asa) asa.addEventListener('keydown', function (e) {
        var actual = parseFloat(getComputedStyle(wrap).getPropertyValue('--cl-corte')) || 50;
        if (e.key === 'ArrowLeft') { wrap.style.setProperty('--cl-corte', Math.max(4, actual - 4) + '%'); e.preventDefault(); }
        if (e.key === 'ArrowRight') { wrap.style.setProperty('--cl-corte', Math.min(96, actual + 4) + '%'); e.preventDefault(); }
      });
    });
  }

  /* --- FAQ --- */
  function initFaq(root) {
    (root || document).querySelectorAll('[data-cl-faq] .cl-faq-item').forEach(function (item) {
      if (item.dataset.clInit) return; item.dataset.clInit = '1';
      var btn = item.querySelector('.cl-faq-preg');
      btn.addEventListener('click', function () {
        var abierta = item.classList.contains('cl-abierta');
        item.parentElement.querySelectorAll('.cl-faq-item').forEach(function (o) { o.classList.remove('cl-abierta'); });
        if (!abierta) item.classList.add('cl-abierta');
        btn.setAttribute('aria-expanded', String(!abierta));
      });
    });
  }

  /* --- CTA magnético --- */
  function initMagnetico(root) {
    if (window.matchMedia('(hover: none)').matches) return;
    (root || document).querySelectorAll('[data-cl-magnetico]').forEach(function (btn) {
      if (btn.dataset.clInit) return; btn.dataset.clInit = '1';
      var zona = 90;
      document.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        var dx = e.clientX - cx, dy = e.clientY - cy;
        var d = Math.hypot(dx, dy);
        if (d < zona + r.width / 2) {
          var f = Math.max(0, 1 - d / (zona + r.width / 2));
          btn.style.transform = 'translate(' + dx * 0.08 * f + 'px,' + dy * 0.12 * f + 'px)';
        } else if (btn.style.transform) { btn.style.transform = ''; }
      }, { passive: true });
    });
  }

  /* --- Marquesina: velocidad según contenido --- */
  function initMarquee(root) {
    (root || document).querySelectorAll('.cl-marquee').forEach(function (m) {
      if (m.dataset.clInit) return; m.dataset.clInit = '1';
      var pista = m.querySelector('.cl-marquee-pista');
      if (!pista) return;
      var seg = parseFloat(m.dataset.clVelocidad || '26');
      pista.style.animationDuration = seg + 's';
    });
  }

  function initTodo(root) {
    initReveals(root); initBeneficios(root); initHotspots(root);
    initComparador(root); initFaq(root); initMagnetico(root); initMarquee(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  } else { initTodo(); }
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
(function () {
  if (window.__clProdInit) return;
  window.__clProdInit = true;

  function initProducto(root) {
    (root || document).querySelectorAll('[data-cl-producto]').forEach(function (sec) {
      if (sec.dataset.clProd) return; sec.dataset.clProd = '1';

      /* galería */
      var fotos = sec.querySelectorAll('.cl-pr-principal img');
      var thumbs = sec.querySelectorAll('.cl-pr-thumb');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = t.dataset.clThumb;
          fotos.forEach(function (f) { f.classList.toggle('cl-activa', f.dataset.clMedia === i); });
          thumbs.forEach(function (o) { o.classList.toggle('cl-activa', o === t); });
        });
      });

      /* variantes */
      var dataEl = sec.querySelector('[data-cl-variantes]');
      if (!dataEl) return;
      var variantes = JSON.parse(dataEl.textContent);
      var grupos = sec.querySelectorAll('.cl-pr-opcion');
      var inputId = sec.querySelector('[data-cl-variante-id]');
      var precio = sec.querySelector('[data-cl-precio]');
      var precioAntes = sec.querySelector('[data-cl-precio-antes]');
      var btn = sec.querySelector('[data-cl-agregar]');
      var btnTextoOriginal = btn ? btn.childNodes[0].textContent.trim() : '';

      function seleccion() {
        return Array.prototype.map.call(grupos, function (g) {
          var a = g.querySelector('.cl-pr-valor.cl-activa');
          return a ? a.dataset.clValor : null;
        });
      }
      function actualizar() {
        var sel = seleccion();
        var v = variantes.find(function (x) {
          return x.opciones.every(function (o, i) { return o === sel[i]; });
        });
        if (!v) return;
        inputId.value = v.id;
        if (precio) precio.textContent = v.precio;
        if (precioAntes) {
          if (v.precio_antes) { precioAntes.textContent = v.precio_antes; precioAntes.hidden = false; }
          else { precioAntes.hidden = true; }
        }
        if (btn) {
          btn.disabled = !v.disponible;
          btn.childNodes[0].textContent = v.disponible ? btnTextoOriginal : (btn.dataset.clAgotado || 'Agotado por ahora');
        }
      }
      grupos.forEach(function (g) {
        g.querySelectorAll('.cl-pr-valor').forEach(function (b) {
          b.addEventListener('click', function () {
            g.querySelectorAll('.cl-pr-valor').forEach(function (o) { o.classList.remove('cl-activa'); });
            b.classList.add('cl-activa');
            actualizar();
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initProducto(); });
  } else { initProducto(); }
  document.addEventListener('shopify:section:load', function (e) { initProducto(e.target); });
})();
